import { Typography } from '@mui/material';
import { useAtom } from 'jotai';

import LargeCard from '@/components/LargeCard';
import { selectedOrganizationAtom } from '@/pages/Organizations';

const AccountManager = () => {
  const [selectedOrganization] = useAtom(selectedOrganizationAtom);

  return (
    <LargeCard title="Account Managers">
      {selectedOrganization?.technical_account_manager && (
        <>
          <Typography variant="h6">Technical Account Manager</Typography>
          <Typography sx={{ pt: 0.5 }} variant="body1">
            {selectedOrganization?.technical_account_manager ||
              'Pondurance Technical Account Manager'}
          </Typography>
          <Typography sx={{ color: 'primary.main' }} variant="body1">
            <a
              style={{ color: 'inherit', textDecoration: 'none' }}
              href={`mailto:${selectedOrganization?.technical_account_manager_email}`}
            >
              {selectedOrganization?.technical_account_manager_email}
            </a>
          </Typography>
        </>
      )}
      <Typography
        sx={{ pt: selectedOrganization?.technical_account_manager ? 2 : 0.5 }}
        variant="h6"
      >
        Sales Account Manager
      </Typography>
      <Typography sx={{ pt: 0.5 }} variant="body1">
        {selectedOrganization?.sales_rep || 'Pondurance Sales Account Manager'}
      </Typography>
      <Typography sx={{ color: 'primary.main' }} variant="body1">
        <a
          style={{ color: 'inherit', textDecoration: 'none' }}
          href={`mailto:${selectedOrganization?.sales_rep_email}`}
        >
          {selectedOrganization?.sales_rep_email}
        </a>
      </Typography>
    </LargeCard>
  );
};

export default AccountManager;
